module.exports = __webpack_public_path__ + "img/Malca-Amit-Logo.5d2bf9fb.svg";